import { render, staticRenderFns } from "./groupes.vue?vue&type=template&id=1a2aeb0b&"
import script from "./groupes.vue?vue&type=script&lang=ts&"
export * from "./groupes.vue?vue&type=script&lang=ts&"
import style0 from "./groupes.vue?vue&type=style&index=0&id=1a2aeb0b&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports